
import { useState } from 'react';

export default function WhyChoose() {
  const [showGiftSection, setShowGiftSection] = useState(true);
  
  const features = [
    {
      icon: 'ri-drop-line',
      title: '한 방울의 차이',
      description: '음식의 풍미를 완전히 다른 차원으로 끌어올리는 프리미엄 품질',
      color: 'from-amber-500 to-yellow-500'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '건강한 프리미엄',
      description: '첨가물 없이 100% 최고급 국산 통깨만을 저온 압착하여 영양소 파괴 최소화',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-gift-line',
      title: '품격있는 선물',
      description: '보내는 분의 정성과 받는 분의 만족을 모두 충족시키는 최고의 명절 선물',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-user-heart-line',
      title: '20년 장인 정신',
      description: '한의사 노태균 원장의 20년 노하우와 건강에 대한 전문 지식이 담긴 역작',
      color: 'from-blue-500 to-indigo-500'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            왜 노원장의 기름을 선택해야 할까요?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            단순한 기름이 아닌, 건강과 맛을 동시에 만족시키는 프리미엄 제품의 차별화된 가치
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group hover:-translate-y-2"
            >
              <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-r ${feature.color} rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-r from-amber-50 to-orange-50 rounded-3xl p-12 text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              🏥 한의사가 직접 만든 건강한 기름
            </h3>
            <div className="grid md:grid-cols-3 gap-8 mb-8">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <i className="ri-stethoscope-line text-4xl text-blue-500 mb-4"></i>
                <h4 className="text-lg font-bold text-gray-900 mb-2">전문의의 노하우</h4>
                <p className="text-gray-600">20년간 환자들의 건강을 생각해온 한의사의 전문적 관점</p>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <i className="ri-leaf-line text-4xl text-green-500 mb-4"></i>
                <h4 className="text-lg font-bold text-gray-900 mb-2">자연 그대로</h4>
                <p className="text-gray-600">화학 처리 없이 자연의 영양소를 그대로 보존하는 저온 압착</p>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <i className="ri-award-line text-4xl text-amber-500 mb-4"></i>
                <h4 className="text-lg font-bold text-gray-900 mb-2">최고급 원료</h4>
                <p className="text-gray-600">국내산 최고급 통깨와 들깨만을 엄선하여 사용</p>
              </div>
            </div>
            <p className="text-lg text-gray-700 mb-8">
              건강을 생각하는 전문의의 마음으로 만든 기름이기에, 
              맛있을 뿐만 아니라 몸에도 좋은 진정한 웰빙 제품입니다.
            </p>
          </div>
        </div>

        {showGiftSection && (
          <div className="mt-16 bg-gradient-to-r from-purple-100 to-pink-100 rounded-3xl p-12 relative">
            <button
              onClick={() => setShowGiftSection(false)}
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors cursor-pointer z-10"
              title="섹션 삭제"
            >
              <i className="ri-close-line text-gray-600 text-xl"></i>
            </button>
            <div className="text-center">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                🎁 명품을 선물하세요
              </h3>
              <p className="text-xl text-gray-700 mb-8">
                소중한 분들에게 건강과 정성이 담긴 프리미엄 선물을 전해보세요
              </p>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <i className="ri-gift-2-line text-5xl text-purple-500 mb-4"></i>
                  <h4 className="text-xl font-bold text-gray-900 mb-4">명절 선물세트</h4>
                  <p className="text-gray-600">참기름과 들기름이 함께 들어있는 프리미엄 선물세트로 특별한 마음을 전하세요</p>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <i className="ri-heart-3-line text-5xl text-pink-500 mb-4"></i>
                  <h4 className="text-xl font-bold text-gray-900 mb-4">건강 선물</h4>
                  <p className="text-gray-600">한의사가 만든 건강한 기름으로 가족의 건강을 생각하는 마음을 표현하세요</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
